import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Message, Segment, Dimmer, Loader, Card, Pagination, Button, } from 'semantic-ui-react'

import RowCard from "./RowCard";

import Select from "react-select";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector, shallowEqual, useDispatch } from "react-redux";

import {
  UPDATE_PDF_TEMPLATE_PAGE_NUMBER,
  SG_GET_PDF_TEMPLATES,
  SG_GET_ORGANIZATION_SELECT
} from "constants/actions";

const TemplateList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  let ReloadPage = searchParams.get("reload");

  // const [organizationSelect, setOrganizationSelect] = useState([])
  const [orgSelected, setOrgSelected] = useState([])

  const [results, setResults] = useState([]);
  const [page, setPage] = React.useState(1);
  // const [loading, setLoading] = useState(false)
  const [totalPages, setTotalPages] = useState(1)

  const {get_pdf_template,
    get_organization_select } = useSelector(
      (state) => ({
        get_pdf_template: state.pdfTemplate.pdf_templates,
        get_organization_select: state.organizations.organization_select,
      }),
      shallowEqual
    );

  useEffect(() => {
    dispatch({
      type: SG_GET_PDF_TEMPLATES,
    });
    dispatch({
      type: SG_GET_ORGANIZATION_SELECT,
    });
  }, [dispatch]);

  useEffect(() => {
    setResults(get_pdf_template?.results);
    setPage(get_pdf_template?.pageNumber)
    setTotalPages(Math.ceil(get_pdf_template?.count / get_pdf_template?.page_size))
    if (get_pdf_template?.count % get_pdf_template?.page_size) {
      setTotalPages(Math.ceil(get_pdf_template?.count / get_pdf_template?.page_size))
    }

  }, [get_pdf_template, page, ReloadPage]);

  useEffect(() => {
    if (ReloadPage) {
      dispatch({
        type: UPDATE_PDF_TEMPLATE_PAGE_NUMBER,
      });

      // const timer = setTimeout(() => {
      //   navigate('/app/questions')
      // }, 1000);
      // return timer

    }
  }, [ReloadPage, navigate, dispatch]);

  function handlePageChange(event, value) {
    setPage(value.activePage);
    dispatch({
      type: UPDATE_PDF_TEMPLATE_PAGE_NUMBER,
      payload: value.activePage,
    });
  }

  function UpdateQuestions() {
    dispatch({
      type: SG_GET_PDF_TEMPLATES,
      payload: `${orgSelected?.id ? `&organization=${orgSelected.id}` : ''}`
    });
  }

  return (
    <Container>
      <Message
        color='orange'
        icon='warning sign'
        header='Do not Modify before you read this'
        content={
          `This data is crucial for the entire survey, please 
          donot change or add anything to this page without 
          consulting support team. Any errors would appear below this message. 
          Please note even if there are no errors things may break if you
          change this file without proper knowledge. To modify please contact
          support.
        `}
      />


      <SingleRowContent>
        
        <SectionCell>

          <Select
            name="org_preference"
            options={get_organization_select}
            isClearable
            onChange={setOrgSelected}
            getOptionLabel={(option) => `${option.name}`}
            getOptionValue={(option) => `${option.id}`}
            value={orgSelected}
          />
        </SectionCell>


        <SectionCell>
          <Button onClick={UpdateQuestions}>Filter</Button>
          <Button
            floated='right'
            color="green"
            onClick={() => navigate(`/app/pdf-templates/new/`)}>
            Add New
          </Button>
        </SectionCell>


      </SingleRowContent>

      <Segment id="results" basic>
        <Dimmer 
        // active={loading}
        >
          <Loader />
        </Dimmer>
        <Card.Group>
          {results ? results.map((result) => (
            <RowCard 
            row={result} 
            key={result?.id}
            get_organization_select={get_organization_select} />
          )) :
          <SectionDiv>
          <p>No results found</p>  
          </SectionDiv>}
        </Card.Group>
      </Segment>
      <SectionDiv>

        <Pagination
          ellipsisItem={null}
          firstItem={null}
          lastItem={null}
          activePage={page}
          totalPages={totalPages ? totalPages : 0}
          onPageChange={handlePageChange}
        />
      </SectionDiv>
    </Container>
  );
};

export default TemplateList;

const Container = styled.div`
  margin-bottom: 30px;
`;

const SectionDiv = styled.div`
    padding: 30px 15px;
`

const SingleRowContent = styled.div`
  display: flex;
  justify-content: flex-start;

`
const SectionCell = styled.div`
    padding: 30px 15px;
    min-width: 350px
`

